export default {
  title: String,
  link: String,
  linkText: {
    type: String,
    default: 'Adicionar +'
  }
}
